import PromoHelper from './PromoHelper'
import React from 'react'
import Box from '@mui/material/Box'
import Header from '../../common/components/Header'
import { Navigate, Route, Routes } from 'react-router-dom'
import TraderAccounts from './TraderAccounts'
import Analytics from './Analytics'
import AccountDetails from './AccountDetails'
import { TraderAccountHelper } from '../contexts/TraderAccountContext'
import DataViewer from './DataViewer'
import SubscriptionSummary from './SubscriptionSummary'
import Footer from '../../common/components/Footer'
import GiftSubscription from './GiftSubscription'
import UserProductReport from './SalesActivityReport'
import AutoTradeReport from './AutoTradeReport'
import Products from './Products'
import AdminNav from '../components/AdminNav'
import { adminColors } from '../adminStyles'

export default function AdminPanel() {
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '95vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1, px: 4, py: 2, bgcolor: adminColors.pageBg }}>
          <AdminNav />
          <TraderAccountHelper>
            <Routes>
              <Route path="/" element={<Navigate to="/admin/accounts" />} />
              <Route path="/accounts" element={<TraderAccounts />} />
              <Route path="/promo" element={<PromoHelper />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/accounts/details" element={<AccountDetails />} />
              <Route path="/data" element={<DataViewer />} />
              <Route path="/summary" element={<SubscriptionSummary />} />
              <Route path="/gift" element={<GiftSubscription />} />
              <Route path="/user-product-report" element={<UserProductReport />} />
              <Route path="/auto-trade-report" element={<AutoTradeReport />} />
              <Route path="/products" element={<Products />} />
            </Routes>
          </TraderAccountHelper>
        </Box>
      </Box>
      <Footer />
    </>
  )
}
